import { Controller } from "@hotwired/stimulus"

// A list that grows as it is read: when this element (the last row) scrolls into
// view it follows its own link, and the turbo_stream that answers appends the next
// rows and swaps this element for the next one — or for nothing on the last page.
// One shot: the response replaces the element, so there is nothing to re-arm. The
// link stays clickable, which is the way through if the request fails.
export default class extends Controller {
  static targets = ["link"]

  connect() {
    this._observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.#load()
    })
    this._observer.observe(this.element)
  }

  disconnect() {
    this._observer?.disconnect()
  }

  #load() {
    this._observer.disconnect()
    this.linkTarget.click()
  }
}
